import TestMessagingContainer from './TestMessagingContainer';
import TestMessagingHelp from './TestMessagingHelp';

export { TestMessagingHelp };
export default TestMessagingContainer;
